
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"#fff","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"3.313","y":"3.742","width":"7.702","height":"3.758","rx":"1.879"}}),_c('path',{attrs:{"d":"M14.756 9.837l.297-.301c.363-.364.337-.977-.026-1.34l-.19-.191c-.364-.364-.977-.39-1.34-.026l-.301.296 1.56 1.563zM7.984 13.48l-.013.013-.935 2.405c-.023.06.036.118.098.098l2.398-.941 4.831-4.836L12.8 8.655l-4.819 4.822.003.003zm-.412 1.485l.474-1.212a.352.352 0 00.092.165.38.38 0 00.314.103l.07-.007-.008.069a.393.393 0 00.106.317c.08.08.188.116.314.103l.07-.007-.008.07a.38.38 0 00.103.313c.049.05.11.08.18.098l-1.218.477-.49-.49zm5.388-5.001l.069.07-3.665 3.668-.07-.07 3.666-3.668zM3.952 8.75a.625.625 0 100 1.25h3.91a.625.625 0 100-1.25h-3.91z"}}),_c('path',{attrs:{"d":"M5.42 14.75H3.33c-.689 0-1.25-.56-1.25-1.25v-11c0-.69.561-1.25 1.25-1.25h7.684c.69 0 1.25.56 1.25 1.25v3.844a.625.625 0 101.25 0V2.5c0-1.379-1.121-2.5-2.5-2.5H3.33a2.503 2.503 0 00-2.5 2.5v11c0 1.379 1.122 2.5 2.5 2.5h2.09a.625.625 0 100-1.25z"}})])
          )
        }
      }
    